import React from 'react';
import About from './AboutSection';
import Blog from './BlogSection';
import Company from './CompanySection';
import CTA from './CtaSection';
import Feature from './FeatureSection';
import Banner from './HomeBanner';
import Project from './ProjectSection';
import Service from './ServiceSection';

const HomeMain = () => {
  return (
    <main>
      <Banner />

      <Feature />

      <About />

      <Service />

      <Project />

      <Company />

      <Blog />

      <CTA />
    </main>
  );
};

export default HomeMain;
